import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const courses = {
  popular_courses: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/courses/popular_courses", params),
  active_students: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/courses/active_students", params),
  dropout_students: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/courses/dropout_students", params),
  quizzes: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/courses/quizzes", params),
  course_activity: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/courses/course_activity", params),
  completion_overview: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/courses/completion_overview",
      params,
    ),
  course_completions: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/courses/course_completions",
      params,
    ),
  completion_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/courses/completion_rate", params),
  course_enrollments: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/courses/course_enrollments",
      params,
    ),
};
